import { createSelector } from "../../utils/selectors.js";
export const selectorChartCartesianAxisState = state => state.cartesianAxis;
export const selectorChartRawXAxis = createSelector(selectorChartCartesianAxisState, axis => axis?.x);
export const selectorChartRawYAxis = createSelector(selectorChartCartesianAxisState, axis => axis?.y);